import Form from "../../assets/js/form/Form";
import { notice } from "JS/utils/notice";
import {generateMagicCode, generateNumbersCode} from "./generateMagicCode";
import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';

class NumbersForm {
    /**
     * @type {Form}
     */
    form;

    isLoading = false;

    /**
     * Показать всю сакральность лоадера
     */
    loaderDelay = 200;

    /**
     * 
     * @param {HTMLFormElement} form 
     */
    constructor(form) {
        if (!form) {
            return;
        }
        this.form = new Form(form);

        this.modalSuccess = document.querySelector('.block-digital-values__modal-wrapper');
        this.modalFinalResult = document.querySelector('.block-digital-values__modal-final-result');
        this.modalResult = document.querySelector('.block-digital-values__modal-result');
        this.input = document.querySelector('input[name="input_numbers"]');
        this.closeBtns = document.querySelectorAll('[data-close-modal]');
        this.methodDescWrapper = document.querySelector('.numbers-form__method-desc-wrapper');
        this.methodDesc = document.querySelector('.numbers-form__method-desc');
        this.methodsSelect = document.querySelector('select[name="numbers_form_select"]');

        this.addListeners();
    }

    addListeners() {
        this.closeBtns.forEach(elm => {
            elm.addEventListener('click', () => {
                this.modalClose();
            });
        });

        this.methodsSelect.addEventListener('change', (e) => {
            this.methodDesc.innerHTML = this.methodsSelect.options[this.methodsSelect.selectedIndex].getAttribute('data-desc');
            this.methodDescWrapper.classList.add('show');
            this.methodDescWrapper.style.height = this.methodDesc.offsetHeight + 'px';
        })

        this.form.on('submit', (data) => {
            if (this.isLoading) {
                return;
            }

            this.submit(data);
        });
    }

    submit(data) {

        const regex = /^[ а-яА-ЯёЁ0-9\s]+$/;
        if (!regex.test(this.input.value)) {
            notice('Используйте только русские символы и числа', 'error');
            return;
        }

        let inputsValues = {};
        let type =''
        for (let key in data) {
            if (key.includes('input')) {
                inputsValues[key] = data[key];
            } else if(key.includes('select')) {
                type = data[key];
            }
        }

        let createString = Object.values(inputsValues).reduce((acc, field) => {
            return acc.concat(field.replace(/\./g, '').replace(/,/g, '').replace(/\s+/g, ''));
        }, '');

        let sourceString = Object.values(inputsValues).reduce((acc, field) => {
            return acc.concat(field);
        }, '');

        if (type === 'magic') {
            const result = generateMagicCode(createString, sourceString)
            result.forEach(val => {
                this.modalResult.innerHTML += val + '</br>';
            })
            this.modalFinalResult.innerHTML = 'Девятизначный код: <b>' + result[result.length - 1] + '</b>';
            this.modalOpen();
        } else if (type === 'numbers') {
            const result = generateNumbersCode(createString, sourceString);
            result.logs.forEach(val => {
                this.modalResult.innerHTML += val + '</br>';
            })
            this.modalFinalResult.innerHTML = `<b>Сумма:</b> ${result.sum}` + `${result.soundString ? `<br><b>Звуковой ряд:</b> ${result.soundString}` : ''}`;
            this.modalOpen();
        } else {
            notice('Пока нет данных', 'error')
        }
    }

    modalOpen() {
        this.modalSuccess.classList.add('modal-open');
        lockScroll();
    }

    modalClose() {
        this.modalSuccess.classList.remove('modal-open');
        unlockScroll();
        setTimeout(() => {
            this.modalResult.innerHTML = '';
            this.modalFinalResult.innerHTML = '';
        }, 200);
    }

}



const numbersForm = document.querySelectorAll('.numbers-form__form');

numbersForm.forEach(form => {
    new NumbersForm(form)
})



